import { apiFetch } from "./client";

export interface CurrencyVolume {
  currency: string;
  approvedCount: number;
  approvedVolume: string;
}

export interface TopMerchant {
  merchantId: string;
  merchantName: string;
  approvedCount: number;
  approvedVolumePyg: string;
}

export interface GlobalBillingStats {
  period: string;
  approvedCount: number;
  rejectedCount: number;
  previousApprovedCount: number;
  activeMerchants: number;
  volumes: CurrencyVolume[];
  topMerchants: TopMerchant[];
}

export interface MerchantBillingStats {
  merchantId: string;
  period: string;
  approvedCount: number;
  rejectedCount: number;
  pendingCount: number;
  volumes: CurrencyVolume[];
}

export const getGlobalBillingStats = (period?: string) =>
  apiFetch<GlobalBillingStats>("/admin/billing/stats", {
    query: { period },
  });

export const getMerchantBillingStats = (merchantId: string, period?: string) =>
  apiFetch<MerchantBillingStats>(
    `/admin/merchants/${merchantId}/billing/stats`,
    { query: { period } },
  );
